<template>
    <div v-if="caixa">
        <v-toolbar flat dense color="primary" app  dark tabs>

            <v-btn icon @click="goBack()">
                <v-icon>arrow_back</v-icon>
            </v-btn>

            <v-toolbar-title>Caixa CTO</v-toolbar-title>

            <v-spacer></v-spacer>

            <v-btn icon @click.stop="reload">
                <v-icon>autorenew</v-icon>
            </v-btn>

            <v-tabs
                    color="primary"
                    slot="extension"
                    grow
                    fixed-tabs
                    v-model="tab"
            >
                <v-tabs-slider color="yellow"></v-tabs-slider>

                <v-tab :key="'dados'" class="white--text">
                    <v-icon class="white--text">description</v-icon> &nbsp; <small>DADOS</small>
                </v-tab>

                <v-tab :key="'user'" class="white--text">
                    <v-icon class="white--text">build</v-icon> &nbsp; <small>PACPON</small>
                </v-tab>

                <v-tab :key="'map'" class="white--text">
                    <v-icon class="white--text">map</v-icon> &nbsp; <small>MAPA</small>
                </v-tab>

            </v-tabs>
        </v-toolbar>

            <v-tabs-items v-model="tab">

                <v-tab-item :key="'dados'">
                    <v-container
                            fluid
                            grid-list-lg
                    >

                        <v-layout justify-center>
                            <v-flex xs12 sm8>
                                <v-card>

                                    <v-card-title class="blue darken-1">
                                        <span class="headline white--text">
                                            <b>Caixa CTO</b><br/><small>{{caixa.nome}}</small>
                                        </span>
                                    </v-card-title>

                                    <v-list>
                                        <v-list-tile v-if="caixa.porta_pon">
                                            <v-list-tile-content>
                                                <v-list-tile-sub-title>PORTA PON</v-list-tile-sub-title>
                                                <v-list-tile-title class="font-weight-bold">{{caixa.porta_pon.nome}}</v-list-tile-title>
                                            </v-list-tile-content>
                                        </v-list-tile>

                                        <v-divider></v-divider>

                                        <v-list-tile v-if="caixa.fibra">
                                            <v-list-tile-content>
                                                <v-list-tile-sub-title>FIBRA</v-list-tile-sub-title>
                                                <v-list-tile-title class="font-weight-bold">{{caixa.fibra.nome}}</v-list-tile-title>
                                            </v-list-tile-content>
                                        </v-list-tile>

                                        <v-divider></v-divider>

                                        <v-list-tile >
                                            <v-list-tile-content>
                                                <v-list-tile-sub-title>VLAN</v-list-tile-sub-title>
                                                <v-list-tile-title class="font-weight-bold">{{(caixa.vlan) ? caixa.vlan : "vlan não cadastrada!"}}</v-list-tile-title>
                                            </v-list-tile-content>
                                        </v-list-tile>

                                        <v-divider></v-divider>

                                        <v-list-tile v-if="caixa.splitter1">
                                            <v-list-tile-content>
                                                <v-list-tile-sub-title>Splitter 1</v-list-tile-sub-title>
                                                <v-list-tile-title class="font-weight-bold">{{caixa.splitter1.potencia}}</v-list-tile-title>
                                            </v-list-tile-content>
                                        </v-list-tile>

                                        <v-divider></v-divider>

                                        <v-list-tile >
                                            <v-list-tile-content>
                                                <v-list-tile-sub-title>Portas</v-list-tile-sub-title>
                                                <v-list-tile-title class="font-weight-bold">{{caixa.portas}}</v-list-tile-title>
                                            </v-list-tile-content>
                                        </v-list-tile>

                                        <v-divider></v-divider>

                                        <v-list-tile v-if="caixa.splitter2">
                                            <v-list-tile-content>
                                                <v-list-tile-sub-title>Splitter 2</v-list-tile-sub-title>
                                                <v-list-tile-title class="font-weight-bold">{{caixa.splitter2.potencia}}</v-list-tile-title>
                                            </v-list-tile-content>
                                        </v-list-tile>

                                        <v-divider></v-divider>

                                        <v-list-tile>
                                            <v-list-tile-content>
                                                <v-list-tile-sub-title>Local</v-list-tile-sub-title>
                                                <v-list-tile-title class="font-weight-bold">{{caixa.local}}</v-list-tile-title>
                                            </v-list-tile-content>
                                        </v-list-tile>

                                    </v-list>

                                </v-card>
                            </v-flex>
                        </v-layout>

                        <v-layout justify-center>
                            <v-flex xs12 sm8>
                                <v-card>

                                    <v-list class="blue lighten-1 white--text">
                                        <v-list-tile>
                                            <v-list-tile-content v-if="caixa.obs">
                                                <span>{{caixa.obs}}</span>
                                                <v-divider></v-divider>
                                            </v-list-tile-content>
                                            <v-list-tile-content v-else>
                                                <span>NENHUMA OBSERVAÇÃO</span>
                                            </v-list-tile-content>
                                        </v-list-tile>
                                    </v-list>

                                </v-card>
                            </v-flex>
                        </v-layout>

                        <v-layout justify-center>
                            <v-flex xs12 sm8>
                                <v-card>

                                    <v-card-title class="blue darken-1">
                                        <span class="headline white--text">
                                            <b>Clientes FTTH</b>
                                        </span>
                                    </v-card-title>

                                    <clientes-ftth-na-caixa :id="caixa._id"></clientes-ftth-na-caixa>

                                </v-card>
                            </v-flex>
                        </v-layout>
                    </v-container>
                </v-tab-item>

                <v-tab-item :key="'user'">
                    <pacpon-na-cto :id="caixa._id" />
                </v-tab-item>

                <v-tab-item :key="'map'">
                    <map-caixa :lat="caixa.place[1]" :lng="caixa.place[0]"/>
                </v-tab-item>

            </v-tabs-items>
    </div>
</template>

<script>
    import { Caixas } from "../../class/caixas"
    import { EventBus } from "../../utils/event-bus"
    import MapCaixa from "../../components/caixa/MapCaixa"
    import PacponNaCto from "../../components/caixa/PacponNaCto"
    import ClientesFtthNaCaixa from "../../components/caixa/ClientesFtthNaCaixa"
    export default {
        name: "ViewCaixa",
        components: {
            MapCaixa, PacponNaCto, ClientesFtthNaCaixa
        },
        data () {
            return {
                tab: 0,
                clipped: true,
                caixa: null
            };
        },
        beforeMount () {
            this.load();
        },
        methods: {
            goBack: function () {
                this.$router.go(-1);
            },
            reload () {
                this.load();
                EventBus.$emit("reloaded", null);
            },
            load () {
                Caixas
                    .caixaCto(this.$route.params.id)
                    .then(ordens => {
                        this.caixa = ordens.data
                    })
                    .catch((err) => console.error(err))
            }
        }
    };
</script>

<style scoped>

</style>
